import { useRepo } from 'pinia-orm'
import { Client } from 'modules/Client/Client'
import { Compartment } from 'modules/Compartment/Compartment'
import { Device } from 'modules/Device/Device'
import { Equipment } from 'modules/Equipment/Equipment'
import MissingDeviceHistory from 'modules/MissingDeviceHistory/MissingDeviceHistory'
import { Project } from 'modules/Project/Project'
import { QrCode } from 'modules/QrCode/QrCode'
import { Tank } from 'modules/Tank/Tank'
import { TankLevelCalibration } from 'modules/TankLevelCalibration/TankLevelCalibration'
import { TankLevelNode } from 'modules/TankLevelNode/TankLevelNode'
import { Transaction } from 'modules/Transaction/Transaction'
import { abortInFlightCatalogSync } from './catalogSyncRun'

export const ORG_SCOPED_CATALOG_MODELS = [
  Equipment,
  Compartment,
  QrCode,
  Project,
  Client,
  Device,
  Tank,
  TankLevelCalibration,
  TankLevelNode,
  Transaction,
  MissingDeviceHistory,
] as const

export function flushOrgScopedCatalogs (): void {
  abortInFlightCatalogSync()
  for (const model of ORG_SCOPED_CATALOG_MODELS) {
    useRepo(model).flush()
  }
}
